import { render, staticRenderFns } from "./AuctionsModuleMenu.vue?vue&type=template&id=e3d0c36e"
import script from "./AuctionsModuleMenu.vue?vue&type=script&lang=js"
export * from "./AuctionsModuleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports